import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LivePreviewService } from '../../../shared/services/live-preview.service';
import { IState } from '../../../../shared/models/state';
import { Store } from '@ngrx/store';
import { getActiveProjectSelector } from '../../../projects/projects.reducer';

@Component({
  selector: 'cc-lg-live-preview-popup',
  templateUrl: './live-preview-popup.component.html',
  styleUrls: ['./live-preview-popup.component.scss']
})
export class LivePreviewPopupComponent implements OnInit {
  public previewHtml: any;
  public state = 'SET_NOT_SUBMITTED';
  public isDesktop = true;
  private projectId: number;

  @Output() previewTypeChanged = new EventEmitter();

  constructor(private livePreviewService: LivePreviewService, private store: Store<IState>) {}

  ngOnInit(): void {
    this.store.select(getActiveProjectSelector).subscribe(data => {
      this.projectId = data && data.projectId;
    });
    this.previewHtml = this.livePreviewService.createPreviewHtml({ popupEditMode: true, projectId: this.projectId });
  }

  changeState(state: string) {
    this.livePreviewService.sendToFrame(state);
    this.state = state;
    this.previewTypeChanged.next(this.isPopup());
  }

  handleChangeDevice(isDesktop) {
    this.isDesktop = isDesktop;
  }

  isPopup() {
    return this.state === 'SET_NOT_SUBMITTED';
  }
}
